import { useSelector, useDispatch } from 'react-redux';

import { statusSelector } from './state/selectors';
import { RequestStatus } from 'shared/constants/State';
import { ready } from './state/saveReducer';

export const useReady = (handler?: Function) => {
  const status = useSelector(statusSelector);
  const dispatch = useDispatch();

  return () => {
    if (status === RequestStatus.Ready) {
      return;
    }

    dispatch(ready());
    if (handler) handler();
  };
};
